import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import HowToDelete from "./pages/HowToDelete/HowToDelete";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import "./styles/global.css";

function App() {
  return (
    <BrowserRouter>
      <div className="app-wrapper">
        <NavBar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HowToDelete />} />
            <Route path="/how-to-delete" element={<HowToDelete />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;